// projectSaga.js
import { call, put, takeLatest } from 'redux-saga/effects';

import { FETCH_PROJECTS_FAILURE, FETCH_PROJECTS_REQUEST, FETCH_PROJECTS_SUCCESS, GET_MY_TASKS_FAILURE, GET_MY_TASKS_REQUEST, GET_MY_TASKS_SUCCESS } from '../Actions/Actions';
import Axios from '../../utils/Axios';
import AuthHandler from '../../utils/AuthHandler';
import { navigate } from '../../utils/navigation';
import { MY_TASK_LIST } from '../../config/API_Collection';
import { getErrorMessage } from '../../config/Error_Codes';



function* fetchTasks() {
  try {
    const response = yield call(Axios.get,MY_TASK_LIST);
    console.warn(response);
    
    const projects = response.data.data || [];
    yield put({type:GET_MY_TASKS_SUCCESS,payload:projects});
  } catch (error) {
    yield call(AuthHandler, error.response?.status, null, navigate);
    yield put({type:GET_MY_TASKS_FAILURE,payload:getErrorMessage(error.status)});
  }
}

export default function* myTaskListSaga() {
  yield takeLatest(GET_MY_TASKS_REQUEST, fetchTasks);
}
